module.exports = __webpack_public_path__ + "img/double-opt-in-1.18a8be1d.png";